/**
 * TASK-837 — this client's value-tag corrections.
 *
 * Separate from `useFit` on purpose. `/fit` carries the overrides that apply to a holding it
 * still returns, and a *removed* exclusion takes the holding out of the conflict list
 * entirely — so a surface that only ever read `/fit`'s conflicts could never show the advisor
 * the correction they had just made, nor let them withdraw it. Reversibility is an acceptance
 * criterion, and a reversal you cannot reach is not one.
 */

import { useQuery } from '@tanstack/react-query';
import { portfolioFitService } from '../services/portfolioFitService';

export function useTagOverrides(clientId: string) {
  return useQuery({
    queryKey: ['tag-overrides', clientId],
    queryFn: () => portfolioFitService.getTagOverrides(clientId),
    enabled: !!clientId,
    staleTime: 60_000,
  });
}
